<template>
  <div class="modal-content p-3">
    <template v-if="props.list.length > 0">
      <div class="form-group mb-3">
        <label class="form-label mb-0">Выберите документы для скачивания</label>
        <div class="form-check" v-for="file in props.list" :key="file.id">
          <input
            class="form-check-input"
            type="checkbox"
            :id="'file-' + file.id"
            :value="file.secure_filename"
            v-model="selected"
          />
          <label class="form-check-label" :for="'file-' + file.id">
            {{ file.filename }}
          </label>
        </div>
        <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="select-all"
            :checked="isAllSelected"
            @change="toggleSelectAll"
          />
          <label class="form-check-label" for="select-all"> Скачать все </label>
        </div>
      </div>
      <div class="d-flex justify-content-start gap-2 mt-3">
        <a
          download
          class="btn btn-success"
          :href="selected.length === 0 ? null : downloadUrl"
          :class="['btn btn-success', { disabled: selected.length === 0 }]"
          :aria-disabled="selected.length === 0"
          @click="$emit('modalstack:close', false)"
        >
          Скачать
        </a>

        <button
          type="button"
          class="btn btn-outline-danger"
          @click="$emit('modalstack:close', false)"
        >
          Вернуться к обращению
        </button>
      </div>
    </template>
    <template v-else>
      <p class="text-muted">Документы для скачивания отсутствуют.</p>
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-secondary" @click="$emit('modalstack:close', false)">
          Закрыть
        </button>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  list: {
    type: Array,
    required: true,
  },
})

const selected = ref([])

const isAllSelected = computed(() => {
  return props.list.length > 0 && selected.value.length === props.list.length
})

function toggleSelectAll(event) {
  if (event.target.checked) {
    selected.value = props.list.map(file => file.secure_filename)
  } else {
    selected.value = []
  }
}

const downloadUrl = computed(() => {
  const files = selected.value.join('|')
  return `/api/v1.0/download/${files}`
})
</script>
